var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"burger",class:{ active: _vm.dValue },on:{"click":_vm.toggleBurger}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }